<template>

  <b-modal

    id="modal-record-payment"

    ref="modal"

    title="Record Payment"

    @ok="handleOk"

    @hidden="reset"

  >

    <b-form>

      <b-form-group label="Invoice Number">

        <b-form-input :value="form.invoice_number" readonly />

      </b-form-group>

      <b-form-group label="Payment Date *">

        <b-form-input v-model="form.payment_date" type="date" />

      </b-form-group>

      <b-form-group label="Amount *">

        <b-form-input

          v-model.number="form.amount"

          type="number"

          step="0.01"

          min="0"

          placeholder="Enter payment amount"

        />

        <small v-if="outstandingAmount > 0" class="text-muted">

          Outstanding: {{ outstandingAmount.toFixed(2) }}

        </small>

      </b-form-group>

      <b-form-group v-if="isPartialPayment" label="Reason for short payment *">

        <b-form-select

          v-model="form.short_payment_reason"

          :options="shortPaymentReasonOptions"

        />

      </b-form-group>

      <b-form-group label="Payment Mode *">

        <b-form-select v-model="form.payment_mode" :options="paymentModeOptions" />

      </b-form-group>

      <b-form-group label="Reference Number">

        <b-form-input v-model="form.reference_number" placeholder="Cheque/UTR/Transaction ID" />

      </b-form-group>

      <b-form-group label="Notes">

        <b-form-textarea

          v-model="form.notes"

          rows="3"

          :placeholder="isPartialPayment ? 'Optional notes (e.g. deduction details)' : 'Additional notes'"

        />

      </b-form-group>

    </b-form>

  </b-modal>

</template>



<script>

import { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue'

import {

  SHORT_PAYMENT_REASONS,

  getShortPaymentReasonLabel,

  buildNotesWithShortPaymentReason,

  isShortPaymentAmount

} from '@/utils/short-payment-reasons'



const emptyForm = () => ({

  invoice_id: null,

  invoice_number: '',

  payment_date: null,

  amount: null,

  payment_mode: null,

  reference_number: '',

  notes: '',

  short_payment_reason: null,

  total_amount: 0,

  previous_paid_amount: 0,

  outstanding_amount: 0

})



export default {

  name: 'RecordPaymentModal',

  components: { BModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormTextarea },

  props: {

    paymentModeOptions: { type: Array, default: () => [] }

  },

  data() {

    return {

      form: emptyForm(),

      shortPaymentReasonOptions: SHORT_PAYMENT_REASONS

    }

  },

  computed: {

    outstandingAmount() {

      const fromForm = Number(this.form.outstanding_amount)

      if (!isNaN(fromForm) && fromForm >= 0) return fromForm

      const total = Number(this.form.total_amount) || 0

      const previousPaid = Number(this.form.previous_paid_amount) || 0

      return Math.max(0, Number((total - previousPaid).toFixed(2)))

    },

    isPartialPayment() {

      return isShortPaymentAmount(this.form.amount, this.outstandingAmount)

    },

    shortPaymentReasonLabel() {

      return getShortPaymentReasonLabel(this.form.short_payment_reason)

    }

  },

  watch: {

    isPartialPayment(val) {

      if (!val) this.form.short_payment_reason = null

    }

  },

  methods: {

    show(invoice) {

      const total = parseFloat(invoice.total_amount) || parseFloat(invoice.amount_with_gst) || 0

      const previousPaid = parseFloat(invoice.paid_amount) || 0

      const parsedOutstanding = parseFloat(invoice.outstanding_amount)

      const outstanding = Math.max(

        0,

        Number((!isNaN(parsedOutstanding) ? parsedOutstanding : (total - previousPaid)).toFixed(2))

      )

      this.form = {

        ...emptyForm(),

        invoice_id: invoice.invoice_id || invoice.id,

        invoice_number: invoice.invoice_id || invoice.invoice_number || '',

        payment_date: new Date().toISOString().slice(0, 10),

        amount: outstanding || null,

        total_amount: total,

        previous_paid_amount: previousPaid,

        outstanding_amount: outstanding

      }

      this.$nextTick(() => this.$refs.modal && this.$refs.modal.show())

    },

    hide() { this.$refs.modal && this.$refs.modal.hide() },

    handleOk(bvEvt) {

      bvEvt.preventDefault()

      if (!this.form.payment_date || !this.form.amount || !this.form.payment_mode) {

        this.$bvToast.toast('Payment Date, Amount, and Mode are required.', { title: 'Validation', variant: 'warning', solid: true })

        return

      }

      const paymentAmount = Number(this.form.amount)

      if (isNaN(paymentAmount) || paymentAmount <= 0) {

        this.$bvToast.toast('Payment amount must be greater than 0.', { title: 'Validation', variant: 'warning', solid: true })

        return

      }

      if (this.isPartialPayment && !this.form.short_payment_reason) {

        this.$bvToast.toast('Please select a reason for short payment.', { title: 'Validation', variant: 'warning', solid: true })

        return

      }



      const paidAmount = Number((Number(this.form.previous_paid_amount || 0) + paymentAmount).toFixed(2))

      const reasonCode = this.isPartialPayment ? this.form.short_payment_reason : null

      const reasonLabel = this.isPartialPayment ? this.shortPaymentReasonLabel : ''

      const notes = this.isPartialPayment

        ? buildNotesWithShortPaymentReason(this.form.notes, reasonLabel)

        : (this.form.notes || '').trim()



      this.$emit('save', {

        ...this.form,

        amount: paymentAmount,

        paid_amount: paidAmount,

        amount_paid: paidAmount,

        notes,

        // Prefer dedicated short-payment fields; also send hold_reason (existing invoice pattern)

        short_payment_reason: reasonCode,

        short_payment_reason_label: reasonLabel || null,

        payment_hold_reason: reasonCode,

        hold_reason: reasonLabel || null

      })

    },

    reset() {

      this.form = emptyForm()

    }

  }

}

</script>

